import { useEffect, useState } from "react";
import api from "../lib/api";

export default function About() {
  const [c, setC] = useState({});
  useEffect(()=>{ api.get("/site/content/about").then(r=>setC(r.data)); }, []);
  return (
    <div className="max-w-3xl mx-auto px-6 py-20">
      <div className="overline mb-3">Our story</div>
      <h1 className="font-display text-5xl md:text-6xl text-dark tracking-tight">{c.title || "About Luxe Watches"}</h1>
      <div className="text-gray-700 leading-relaxed text-lg mt-8 whitespace-pre-line">{c.body}</div>
      <div className="grid md:grid-cols-3 gap-6 mt-16">
        {[{ n: "12+", l: "Authorized brands" }, { n: "500+", l: "Authentic timepieces" }, { n: "24/7", l: "Concierge service" }].map((s,i)=>(
          <div key={i} className="card-luxe p-8 text-center">
            <div className="font-display text-5xl text-copper">{s.n}</div>
            <div className="text-xs uppercase tracking-luxe text-gray-500 mt-2">{s.l}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
